// Recovered compiled webpack factory 5240. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  function r(e) {
    let t = e.indexOf("#"),
      r = e.indexOf("?"),
      n = r > -1 && (t < 0 || r < t);
    return n || t > -1
      ? {
          pathname: e.substring(0, n ? r : t),
          query: n ? e.substring(r, t > -1 ? t : void 0) : "",
          hash: t > -1 ? e.slice(t) : "",
        }
      : { pathname: e, query: "", hash: "" };
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "parsePath", {
      enumerable: !0,
      get: function () {
        return r;
      },
    }));
}
